<script>
import LandingLayout from '@/Shared/LandingLayout.vue';
import LandingFeatureCard from './partials/LandingFeatureCard.vue';
import SmartBreadcrumbs from '@/components/SmartBreadcrumbs.vue';

export default {
    props: {
        meta: Object,
    },
    components: {
        SmartBreadcrumbs,
        LandingFeatureCard: LandingFeatureCard,
    },
    layout: LandingLayout,
    mounted() {
        this.$i18n.locale = this.meta.locale;
    },
};
</script>
<template>
    <div class="bg-gray-100">
        <div class="lg:mx-auto lg:max-w-7xl lg:px-8 py-2">
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('landing.user_roles'),
                        href: meta.links.landing,
                    },
                    {
                        name: $tc('messages.teachers', 2),

                        href: null,
                    },
                ]"
            />
        </div>
    </div>
    <div class="lg:mx-auto lg:max-w-7xl lg:px-8 mt-5">
        <div class="flex flex-col gap-4">
            <LandingFeatureCard
                :title="$t('landing.teachers.section01.item1_title')"
                :description="$t('landing.teachers.section01.item1_description')"
                icon="/img/new_landing/t_school.png"
                screenshot="/img/new_landing/teachers/school_admin.jpg"
            />
            <LandingFeatureCard
                :title="$t('landing.teachers.section01.item2_title')"
                :description="$t('landing.teachers.section01.item2_description')"
                icon="/img/new_landing/t_math.png"
                screenshot="/img/new_landing/teachers/turing.jpg"
                :url="meta.links.turing"
            />
            <LandingFeatureCard
                :title="$t('landing.teachers.section01.item3_title')"
                :description="$t('landing.teachers.section01.item3_description')"
                icon="/img/new_landing/t_gamification.png"
                screenshot="/img/new_landing/teachers/gamification.jpg"
            />
            <LandingFeatureCard
                :title="$t('landing.teachers.section01.item4_title')"
                :description="$t('landing.teachers.section01.item4_description')"
                icon="/img/new_landing/t_activities.png"
                screenshot="/img/new_landing/teachers/activities.jpg"
            />
            <LandingFeatureCard
                :title="$t('landing.teachers.section01.item5_title')"
                :description="$t('landing.teachers.section01.item5_description')"
                icon="/img/new_landing/t_evaluation.png"
                screenshot="/img/new_landing/teachers/evaluation.jpg"
            />
            <LandingFeatureCard
                :title="$t('landing.teachers.section01.item6_title')"
                :description="$t('landing.teachers.section01.item6_description')"
                icon="/img/new_landing/t_earth.png"
                screenshot="/img/new_landing/teachers/esfera.jpg"
                :url="meta.links.esfera"
            />
            <LandingFeatureCard
                :title="$t('landing.teachers.section01.item7_title')"
                :description="$t('landing.teachers.section01.item7_description')"
                icon="/img/new_landing/t_groups.png"
                screenshot="/img/new_landing/teachers/sociogram.png"
                :url="meta.links.nexa"
            />
            <LandingFeatureCard
                :title="$t('landing.teachers.section01.item8_title')"
                :description="$t('landing.teachers.section01.item8_description')"
                icon="/img/new_landing/t_ai.png"
                screenshot="/img/new_landing/teachers/ia.jpg"
            />
        </div>
    </div>
    <!--    contact-->
</template>
